import { render, staticRenderFns } from "./newDetail.vue?vue&type=template&id=d1ce91c8&scoped=true&"
import script from "./newDetail.vue?vue&type=script&lang=js&"
export * from "./newDetail.vue?vue&type=script&lang=js&"
import style0 from "./newDetail.vue?vue&type=style&index=0&id=d1ce91c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ce91c8",
  null
  
)

export default component.exports